<div id="modal-header">
  <div id="modal-title">
    <mat-icon class="color-primary">help</mat-icon>
    <span class="color-primary">{{ 'forecast.details.title' | translate }}</span>
  </div>
  <button mat-icon-button class="color-primary mic-icon-button-large" (click)="closeModal()">
    <mat-icon class="color-primary">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div id="stocks">
    <span class="description-title">{{ 'forecast.details.stocks.title' | translate }}</span>
    <ul>
      <li>{{ 'forecast.details.stocks.description1' | translate }}</li>
      <li>{{ 'forecast.details.stocks.description2' | translate }}</li>
    </ul>
  </div>
  <div id="fitments">
    <span class="description-title">{{ 'forecast.details.fitment.title' | translate }}</span>
    <ul>
      <li>{{ 'forecast.details.fitment.description1' | translate }}</li>
    </ul>
    <span>{{ 'forecast.details.fitment.description2' | translate }}</span>
    <ul>
      <li>{{ 'forecast.details.fitment.description3' | translate }}</li>
      <li>{{ 'forecast.details.fitment.description4' | translate }}</li>
      <li>{{ 'forecast.details.fitment.description5' | translate }}</li>
    </ul>
  </div>
  <div id="replenishment">
    <span class="description-title">{{ 'forecast.details.replenishment.title' | translate }}</span>
    <ul>
      <li>{{ 'forecast.details.replenishment.description1' | translate }}</li>
      <li>{{ 'forecast.details.replenishment.description2' | translate }}</li>
    </ul>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button (click)="closeModal()">
    {{ 'forecast.details.close' | translate }}
  </button>
</mat-dialog-actions>
